import { Component, Input } from '@angular/core';
import { MarkantElementsModule } from '@markant/elements-angular';
import { SharedLanguageSelectionFeatureModule } from '@markant-platform/shared/language-selection/feature';
import { TranslocoPipe } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'markant-platform-registration-header',
  templateUrl: './registration-header.component.html',
  styleUrls: ['./registration-header.component.scss'],
  imports: [MarkantElementsModule, SharedLanguageSelectionFeatureModule, TranslocoPipe, CommonModule],
})
export class RegistrationHeaderComponent {
  @Input() loginButton = true;
  @Input() isLogoutPage = false;

  readonly MARKANT_WEBSITE_URL = 'https://www.markant.com';

  toLoginPage(): void {
    window.location.href = window.location.origin + '/platform';
  }

  toLandingPage(): void {
    window.location.href = window.location.origin;
  }

  toMarkantWebsite(): void {
    window.location.href = this.MARKANT_WEBSITE_URL;
  }
}
